angular.module('LeasePilot').controller('PersonalInformationController', [
  '$scope',
  '$http',
  '$mdToast',
  function($scope, $http, $mdToast) {
    $scope.user = {};
    $scope.originalUser = {};
    $scope.saving = false;

    // Simple sanitizer for plain-text inputs: strips tags and Angular expressions
    $scope.sanitize = function(value) {
      if (value === null || value === undefined) return '';
      var str = String(value);
      // Remove any HTML tags
      str = str.replace(/<[^>]*>/g, '');
      // Remove Angular-style interpolation expressions
      str = str.replace(/\{\{[\s\S]*?\}\}/g, '');
      // Neutralize javascript: URIs if any text tries to include them
      str = str.replace(/javascript:/gi, '');
      return str.trim();
    };

    function sanitizeUser(user) {
      if (!user) return user;
      return {
        id: user.id,
        first_name: $scope.sanitize(user.first_name),
        last_name: $scope.sanitize(user.last_name),
        email: $scope.sanitize(user.email)
      };
    }

    function isValidEmail(email) {
      if (!email) return false;
      // Lightweight RFC 5322-inspired email validation
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }

    function showToast(message, type = "success") {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(message)
          .position("top right")
          .hideDelay(3000)
          .theme(type === "error" ? "error-toast" : "success-toast")
      );
    }

    $scope.init = function(userData) {
      var cleaned = sanitizeUser(userData);
      $scope.user = cleaned;
      $scope.originalUser = angular.copy(cleaned);
    };

    $scope.hasChanges = function() {
      return !angular.equals($scope.user, $scope.originalUser);
    };

    $scope.saveChanges = function() {
      if (!$scope.hasChanges()) return;

      $scope.saving = true;
      var payloadUser = sanitizeUser($scope.user);
      if (!isValidEmail(payloadUser.email)) {
        $scope.saving = false;
        showToast('Please enter a valid email address', 'error');
        return;
      }

      $http.put('/api/personal_information/' + payloadUser.id, {
        user: {
          first_name: payloadUser.first_name,
          last_name: payloadUser.last_name,
          email: payloadUser.email
        }
      }).then(function(response) {
        $scope.user = response.data;
        $scope.originalUser = angular.copy($scope.user);
        showToast('Personal information updated successfully');
      }).catch(function(error) {
        showToast(error.data.error || 'Failed to update personal information', 'error');
      }).finally(function() {
        $scope.saving = false;
      });
    };
  }
]); 